export function isElementInView(element: HTMLElement, threshold?: number) {
  const rect = element.getBoundingClientRect();
  const {top, bottom} = rect;
  const {innerHeight} = window;
  return top < innerHeight + (threshold ?? 0) && bottom > 0;
}
